import styled from "styled-components";

export const ContextMenu = styled.div<{ $top: number; $left: number }>`
	position: absolute;
	width: 200px;
	background-color: #383838;
	border-radius: 5px;
	box-sizing: border-box;
	top: ${(props) => props.$top}px;
	left: ${(props) => props.$left}px;
	ul {
		box-sizing: border-box;
		padding: 10px;
		margin: 0;
		list-style: none;
	}
	ul li {
		padding: 1px 12px;
		color: #fff;
		width: 100%;
	}

	ul li:hover {
		cursor: pointer;
		background-color: #000000;
	}
`;
